<template>
    <div
        class="reference-avatar"
        :style="{ backgroundColor: avatarColor }"
    >{{ avatarText }}</div>
</template>

<script>
const AVATAR_COLORS = [
    '#178eaf', // blue
    '#858ac9', // purple
    '#1abc9c', // teal
    '#e67e22', // orange
    '#e74c3c', // red
    '#16a085', // dark teal
    '#2980b9', // deep blue
    '#8e44ad', // violet
    '#c0392b', // dark red
    '#27ae60', // green
]

export default {
    name: 'ReferenceAvatar',
    props: {
        reference: {
            type: String,
            default: '',
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        avatarText() {
            const value = (this.reference || '').trim()
            if (!value) return '#'
            // Numeric reference (ignoring spaces) → '#'
            if (/^[\d\s]+$/.test(value)) return '#'
            // String reference → up to 2 initials
            return value
                .split(/\s+/)
                .filter(Boolean)
                .slice(0, 2)
                .map(word => word.charAt(0).toUpperCase())
                .join('')
        },
        avatarColor() {
            return AVATAR_COLORS[this.index % AVATAR_COLORS.length]
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .reference-avatar {
        flex: 0 0 auto;
        width: 2.25rem;
        height: 2.25rem;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $lightest;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: 550;
        font-size: 0.72rem;
        line-height: 1;
        text-align: center;
        text-transform: uppercase;
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// ReferenceAvatar.vue?88714ef0